import request from "@/utils/request";
import {cmsServerContext} from "@/config/config";

/**
 * 发送邮件
 * @param addr 接收邮箱
 * @param from 发送方名称
 * @param subject 主题
 * @param content 内容
 * @param endnote 尾注
 */
export function sendMail(addr,from,subject,content,endnote) {
  return request({
    url: cmsServerContext + '/cmsService/sendMail',
    method: 'post',
    data: {addr:addr,from:from,subject:subject,content:content,endnote:endnote}
  })
}